export {default, getServerSideProps} from '@/common/pages/home/root';
